<script lang="ts">
  import { Check } from 'lucide-svelte';
  import type { QuotationStatus } from '$lib/types';

  const { status }: { status: QuotationStatus } = $props();

  const STEPS = ['Draft', 'Submitted', 'Priced', 'Approved'];
  const STEP_INDEX: Record<QuotationStatus, number> = {
    draft: 0,
    revised: 0,
    submitted: 1,
    priced: 2,
    approved: 3
  };
  const current = $derived(STEP_INDEX[status] ?? 0);
</script>

<div class="tym-card p-[18px]">
  <div class="text-[10.5px] font-semibold tracking-[.06em] uppercase text-dark-gray mb-3.5">Progress</div>
  <div class="flex flex-col">
    {#each STEPS as label, i (label)}
      <div class="flex items-center gap-3 pb-3.5 last:pb-0">
        {#if i < current}
          <!-- Fixed navy (not the adaptive `text-navy`): this sits on the
               always-lime CTA-colored dot, so it must stay dark in both
               themes. -->
          <span class="w-[22px] h-[22px] rounded-full bg-toyama-lime shrink-0 flex items-center justify-center">
            <Check class="h-3.5 w-3.5 text-[var(--tym-navy-800)]" />
          </span>
          <span class="text-[13px] text-navy font-medium">{label}</span>
        {:else if i === current}
          <!-- Fixed navy background (not adaptive `bg-navy`) so the
               white step number stays legible in both themes. -->
          <span class="w-[22px] h-[22px] rounded-full bg-[var(--tym-navy-800)] text-white shrink-0 flex items-center justify-center text-[11px] font-semibold">
            {i + 1}
          </span>
          <span class="text-[13px] text-navy font-bold">{label}</span>
        {:else}
          <span class="w-[22px] h-[22px] rounded-full bg-toyama-light-carbon border border-toyama-cloudy-gray text-dark-gray shrink-0 flex items-center justify-center text-[11px] font-semibold">
            {i + 1}
          </span>
          <span class="text-[13px] text-dark-gray">{label}</span>
        {/if}
      </div>
    {/each}
  </div>
</div>
